var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40.0001C31.0457 40.0001 40 31.0458 40 20.0001C40 8.95443 31.0457 0.00012207 20 0.00012207C8.9543 0.00012207 0 8.95443 0 20.0001C0 31.0458 8.9543 40.0001 20 40.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8307 17.3913H15.6523H15.6522V0.475403C13.8039 0.885247 12.0516 1.54954 10.4348 2.43181V17.3912V17.3913H0.169297C0.0579688 18.2452 0 19.1159 0 20C0 20.8842 0.0579688 21.7548 0.169297 22.6087H10.4347H10.4348V37.5681C12.0516 38.4503 13.8039 39.1148 15.6522 39.5245V22.6089V22.6088H39.8307C39.9419 21.7548 40 20.8842 40 20C40 19.1159 39.9419 18.2452 39.8307 17.3913V17.3913Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinland);
export default __webpack_public_path__ + "static/media/finland.f831dbc9deb483584df44054bcb4f6fb.svg";
export { ForwardRef as ReactComponent };